import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import ResultsBase from "@/views/ResultsBase.vue";
import ResultsLayout from "@/views/ResultsLayout.vue";
import Standings from "@/views/Standings.vue";
import Answers from "@/views/Answers.vue";
import Photowall from "@/views/Photowall.vue";
import Map from "@/views/Map.vue";
import Slideshow from "@/views/Slideshow.vue";
import SlideshowIndex from "@/views/SlideshowIndex.vue";
import SlideshowSlide from "@/views/SlideshowSlide.vue";
import Dev from "@/views/Dev.vue";
import Chat from "@/views/Chat.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/:game",
    component: ResultsBase,
    children: [
      {
        path: "slideshow",
        component: Slideshow,
        children: [
          { path: "/", name: "SlideshowIndex", component: SlideshowIndex },
          { path: ":medium", name: "SlideshowSlide", component: SlideshowSlide }
        ]
      },
      {
        path: "/",
        component: ResultsLayout,
        children: [
          { path: "/", name: "Standings", component: Standings },
          { path: "answers", name: "Answers", component: Answers },
          { path: "media", name: "Photowall", component: Photowall },
          { path: "map", name: "Map", component: Map },
          { path: "chat", name: "Chat", component: Chat },
          { path: "dev", component: Dev }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
